import React, { Component } from 'react';

import './FileDropzone.css';

export default class FileDropzone extends Component {
    constructor(props) {
        super(props)
        this.state = { hightlight: "" };
        this.fileInputRef = React.createRef();

        this.openFileDialog = this.openFileDialog.bind(this);
        this.onFilesAdded   = this.onFilesAdded.bind(this);
        this.onDragOver     = this.onDragOver.bind(this);
        this.onDragLeave    = this.onDragLeave.bind(this);
        this.onDrop         = this.onDrop.bind(this);
    }

    openFileDialog() {
        this.fileInputRef.current.click();
    }

    onFilesAdded(evt) {
        // преобразуем список в обычный массив
        const files = evt.target.files;
        let array =[];
        for (var i = 0; i < files.length; i++)
            array.push(files.item(i));
        // вызываем колбек
        if (this.props.onFilesAdded)
            this.props.onFilesAdded(array);
    }

    onDrop(event) {
        event.preventDefault();
        // преобразуем список в обычный массив
        const files = event.dataTransfer.files;
        let array =[];
        for (var i = 0; i < files.length; i++)
            array.push(files.item(i));
        // вызываем колбек
        if (this.props.onFilesAdded)
            this.props.onFilesAdded(array);
        this.setState({ hightlight: "" });
    }

    onDragOver(evt) {
        evt.preventDefault();
        this.setState({ hightlight: "ZoneHighlight" });
    }

    onDragLeave() {
        this.setState({ hightlight: "" });
    }
  
    render() {
        return (
            <div className={"p-1 " + this.state.hightlight } 
                onDragOver={this.onDragOver} 
                onDragLeave={this.onDragLeave} 
                onDrop={this.onDrop} >

                {this.props.children}
                
                <div className="d-flex w-100 flex-column align-items-center my-4 p-4 Dropzone">

                    <img src="img/cloud-upload.svg" 
                        alt="upload" 
                        height="150" 
                        onClick={this.openFileDialog} 
                        style={{ cursor: "pointer" }} />
                    
                    <input ref={this.fileInputRef} 
                        className="InvisibleFileInput" 
                        type="file" multiple 
                        onChange={this.onFilesAdded} />
                    
                    <button type="button" 
                        className="btn btn-secondary btn-lg mb-3" 
                        onClick={this.openFileDialog}>Загрузите файлы</button>
                    
                    <center><p>Или перетащите файлы сюда для закачки</p></center>
                </div>
            </div>
        );
    }
}